module.exports = __webpack_public_path__ + "img/2.5c4480c0.png";